var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSbpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167029",
    "data-name": "Group 167029",
    transform: "translate(-71 -131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0411\\u041F_\\u043B\\u043E\\u0433\\u043E\\u0442\\u0438\\u043F",
    transform: "translate(83 140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M0,26.12l3.286,5.874v3.583L0,41.44Z",
    transform: "translate(0 -20.213)",
    fill: "#5b57a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M55.8,36.164l3.079-1.887,6.3-.006L55.8,40.018Z",
    transform: "translate(-43.179 -26.521)",
    fill: "#d90751"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M44.508,5.872l.017,7.777-3.294-2.024V0l3.277,5.872Z",
    transform: "translate(-31.907)",
    fill: "#fab718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M53.907,7.75l-6.3.006-3.1-1.884L41.231,0,53.907,7.75Z",
    transform: "translate(-31.907)",
    fill: "#ed6f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M44.525,74.3V70.528l-3.294-1.986,0,11.637Z",
    transform: "translate(-31.907 -53.041)",
    fill: "#63b22f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M15.69,39.6l-12.4-7.608L0,26.12,21.987,39.594l-6.3.008Z",
    transform: "translate(0 -20.213)",
    fill: "#1487c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M41.24,93.459l3.292-5.878,3.072-1.87,6.3-.008Z",
    transform: "translate(-31.914 -66.322)",
    fill: "#017f36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M.017,67.671l9.347-5.726L6.222,60.017,3.3,61.809Z",
    transform: "translate(-0.013 -46.444)",
    fill: "#984995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbpIcon);
export default __webpack_public_path__ + "static/media/sbp_icon.314604454bd57765c40a018c15a08775.svg";
export { ForwardRef as ReactComponent };